// extracted by mini-css-extract-plugin
export default {"category":"CategoriesBody_category__gZiIJ","mt6":"CategoriesBody_mt6__jc2so","maxHeight":"CategoriesBody_maxHeight__N9AfZ"};